// extracted by mini-css-extract-plugin
export default {"modal":"EditCardModal_modal__OGJVe","formContainer":"EditCardModal_formContainer__Whgze"};